import { render } from "./BetListItem.vue?vue&type=template&id=fff1bd6c&scoped=true"
import script from "./BetListItem.vue?vue&type=script&lang=js"
export * from "./BetListItem.vue?vue&type=script&lang=js"

import "./BetListItem.vue?vue&type=style&index=0&id=fff1bd6c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fff1bd6c"]])

export default __exports__